import React from "react";
import "./historylist.scss";
import { Typography } from "@mui/material";
import historyError from "../../../assets/images/historyError.svg";
import { useLocale } from "../../../i18n/I18nProvider";
import { useSection } from "../../../i18n/useSection";
import { getModuleName } from "../../../utlis/measurementModuleLabels";

const HistoryList = ({ data }) => {
  const { no_history } = useSection("history");
  const { locale } = useLocale();
  const getDate = (date) => {
    // API uses -1 as a "no time recorded" sentinel; treat any non-positive
    // or unparseable value as missing rather than rendering Dec 31 1969.
    if (date == null || (typeof date === "number" && date <= 0)) return "";
    const res = new Date(date);
    if (Number.isNaN(res.getTime())) return "";
    const month = res.toLocaleString("default", {
      month: "long",
      timeZone: "UTC",
    });
    const dateFinal =
      month + " " + res.getUTCDate() + " " + res.getUTCFullYear();
    // const dateForJa = res.getUTCFullYear() + "  " + month + "  " + res.getUTCDate();
    const times = res.toLocaleString("en-US", {
      hour: "numeric",
      minute: "numeric",
      hour12: true,
      timeZone: "UTC",
    });
    let options = {
      year: "numeric",
      month: "long",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      // second: "2-digit",
      hour12: true,
      timeZone: "UTC",
    };
    let jstFormattedDate = res.toLocaleString("ja-JP", options);
    let hour = res.getUTCHours();
    let amPm = hour < 12 ? "午前" : "午後";
    jstFormattedDate = jstFormattedDate.replace(/午前|午後/, "").trim(); // Remove default AM/PM
    let xx =
      locale === "ja"
        ? jstFormattedDate + " " + amPm
        : locale === "en"
          ? dateFinal + " " + times
          : res.toLocaleString(locale, {
              year: "numeric",
              month: "long",
              day: "numeric",
              hour: "numeric",
              minute: "2-digit",
              timeZone: "UTC",
            });
    return xx;
  };
  return (
    <>
      {data?.length > 0 ? (
        data?.map((item, index) => {
          return (
            <div className="history-list-wrap" key={index}>
              <div className="test-name-wrap">
                <img src={item?.iconURL} alt="" className="img" />
                <Typography className="test-name">
                  {getModuleName(item)}
                </Typography>
              </div>
              <div className="time-and-report-view-block">
                {getDate(item?.reportTime) && (
                  <Typography className="date-time">
                    {getDate(item?.reportTime)}
                  </Typography>
                )}
              </div>
            </div>
          );
        })
      ) : (
        <div className="history-error-wrap">
          <img src={historyError} alt="" className="img" />
          <Typography className="history-error-text">{no_history}</Typography>
        </div>
      )}
    </>
  );
};

export default HistoryList;
